export function setAutoFocus(parentElement: HTMLElement): void {
  const focusableElementsSelector: string[] = [
    'button:not([disabled])',
    '[href]:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ];
  const focusableElements: NodeListOf<HTMLElement> = parentElement.querySelectorAll(
    focusableElementsSelector.join(', ')
  );

  if (focusableElements.length) {
    const firstFocusableElement: HTMLElement = focusableElements[0];
    firstFocusableElement.focus();
  }
}
